import React from "react";

const RadioButton = ({ value, onChange, checked, title }) => {
  return (
    <div className="flex items-center gap-x-3">
      <label htmlFor={title} className="radio-label">
        <input
          className="radio-input"
          type="radio"
          name={title}
          id={title}
          value={value}
          onChange={onChange}
          checked={checked}
        />
        <span className="custom-radio" />
      </label>
      <label className="font-size-small" htmlFor={title}>
        {title}
      </label>
    </div>
  );
};

export default RadioButton;
